var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty01A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Empty-01a__Modul/Playlist/Empty-01a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Empty-01a__Group",
    transform: "translate(13 3)",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Empty-01a__Rectangle",
    d: "M-1.27897692e-13 0 19.3649414-1.0658141e-14 24 4.86390187 24 32-1.27897692e-13 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Empty-01a__Path",
    d: "M24 5.47119141 18.6367188 5.47119141 18.6367188-1.43746126e-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4852814,14 L29.8994949,15.4142136 L26.364,18.95 L29.8994949,22.4852814 L28.4852814,23.8994949 L24.95,20.364 L21.4142136,23.8994949 L20,22.4852814 L23.536,18.95 L20,15.4142136 L21.4142136,14 L24.95,17.536 L28.4852814,14 Z",
    id: ".._.._src_svg_Modul_Playlist_Empty-01a__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty01A);
export default __webpack_public_path__ + "static/media/Empty-01a.fe8ae398802db67681ae4d24851417b9.svg";
export { ForwardRef as ReactComponent };